import type { ChatMessage } from '@/signalr';

export type IncidentChatState = {
  messages: ChatMessage[] | null;
  callerMessagePreview: string | null;
  isCallerSendingImage: boolean;
  isChatLoading: boolean;
  loadFailed: boolean;
  translateChat: boolean;
  isSendingImage: boolean;
};

export const INITIAL_INCIDENT_CHAT_STATE: IncidentChatState = {
  messages: null,
  callerMessagePreview: null,
  isCallerSendingImage: false,
  isChatLoading: true,
  loadFailed: false,
  translateChat: false,
  isSendingImage: false,
};

export type IncidentChatAction =
  | { type: 'loading-started' }
  | { type: 'messages-loaded'; messages: ChatMessage[] | null }
  | {
      type: 'hub-state-loaded';
      callerMessagePreview: string | null;
      isCallerSendingImage: boolean;
      translateChat: boolean;
    }
  | { type: 'loading-finished' }
  | { type: 'loading-failed' }
  | { type: 'new-message-received'; message: ChatMessage }
  | { type: 'caller-text-preview-received'; messagePreview: string | null }
  | { type: 'caller-image-preview-received'; isSendingImage: boolean }
  | { type: 'translations-allowed-changed'; translateChat: boolean }
  | { type: 'send-image-started' }
  | { type: 'send-image-finished' };

export function incidentChatReducer(state: IncidentChatState, action: IncidentChatAction): IncidentChatState {
  switch (action.type) {
    case 'loading-started':
      return { ...state, isChatLoading: true, loadFailed: false };
    case 'messages-loaded':
      return { ...state, messages: action.messages, loadFailed: false };
    case 'hub-state-loaded':
      return {
        ...state,
        callerMessagePreview: action.callerMessagePreview,
        isCallerSendingImage: action.isCallerSendingImage,
        translateChat: action.translateChat,
      };
    case 'loading-finished':
      return { ...state, isChatLoading: false };
    case 'loading-failed':
      return { ...state, isChatLoading: false, loadFailed: true };
    case 'new-message-received':
      return state.messages === null ? state : { ...state, messages: [...state.messages, action.message] };
    case 'caller-text-preview-received':
      return { ...state, callerMessagePreview: action.messagePreview };
    case 'caller-image-preview-received':
      return { ...state, isCallerSendingImage: action.isSendingImage };
    case 'translations-allowed-changed':
      return { ...state, translateChat: action.translateChat };
    case 'send-image-started':
      return { ...state, isSendingImage: true };
    case 'send-image-finished':
      return { ...state, isSendingImage: false };
  }
}
